"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinRoutes = void 0;
const auth_route_1 = require("./auth_route");
class PinRoutes extends auth_route_1.AuthRoute {
    constructor() {
        super('pin');
    }
    /**
     * Get the length of the PIN for the current user.
     */
    getPinLength() {
        return this.get(`/length`);
    }
    /**
     * Add a PIN to the user account.
     * Will fail if user already has pin set.
     * @param { string } pin
     */
    createPin(pin) {
        return this.post(`/create`, { pin });
    }
    /**
     * Change a user's PIN
     * Will fail if the old PIN does not match the user's current PIN.
     * @param { string } oldPin
     * @param { string } newPin
     */
    changePin(oldPin, newPin) {
        return this.post(`/change`, { oldPin, newPin });
    }
    /**
     * Determine if the PIN is valid for the current user.
     * Will return HTTP 200 if the PIN is valid, and an error code otherwise.
     * @param { string } pin
     */
    validatePin(pin) {
        return this.post(`/validate`, { pin });
    }
}
exports.PinRoutes = PinRoutes;
//# sourceMappingURL=pin.js.map